import MdProfileDashboard from '../pages/MdProfileDashboardv2';

const MdProfileDashboardRoute = {
  public: [],
  auth: [
    {
      name: 'md_profile_dashbaord_page',
      path: '/dashboard/md-profile',
      permissions: ['admin', 'KASM', 'KASROM', 'KASOM', 'SAM', 'RSM', 'COO', 'EXECUTIVE'],
      component: MdProfileDashboard,
    },
  ],
};

export default MdProfileDashboardRoute;
